// extracted by mini-css-extract-plugin
export default {"clarification":"RegisterPage_clarification__poATh","link":"RegisterPage_link__R08Ce"};